import React, { useEffect } from 'react';
import { fetchConToken } from 'helpers/fetch';
import { alertService } from '_services';
import { useHistory } from 'react-router-dom';
import SLUGS from 'resources/slugs';
import {
    IconCanalesventa,
    IconArticulos,
    IconDashboard,
    IconMensajes,
    IconInventarios,
    IconVentas,
    IconCompras,
    IconCxc,
    IconCxp,
    IconRuta,
    IconCatalogos,
    IconSoporte,
    IconSalir,
    IconDolar
} from 'assets/icons';
import LogoComponent from './LogoComponent';
import Menu from './MenuComponent';
import MenuItem from './MenuItemComponent';
import { getDataSession, removeUserSession } from 'views/Utils/Common';
import { setDataSession } from 'views/Utils/Common';
import SidebarOptionsComponent from './SidebarOptionsComponent';

import Swal from 'sweetalert2';

let lista = [
    {
        id: SLUGS.dashboard,
        imagen: IconDashboard,
        onClick: SLUGS.dashboard,
        menu: 'Principal',
        title: 'Dashboard',
        EMPRESA: 'EMPRESA',
        SUCURSAL: 'SUCURSAL'
    },
    /*{
        id: SLUGS.vxubicacion,
        imagen: IconArticles,
        items: [1],
        onClick: SLUGS.vxubicacion,
        menu: 'Monitoreo',
        title: 'Monitoreo',
        EMPRESA: 'EMPRESA',
        SUCURSAL: 'SUCURSAL'
    },*/
    {
        id: SLUGS.sucursal,
        imagen: IconCanalesventa,
        onClick: SLUGS.sucursal,
        menu: 'Conexiones',
        title: 'Canales de venta',
        EMPRESA: 'EMPRESA',
        SUCURSAL: 'SUCURSAL'
    },
    /*{
        id: SLUGS.planesyprecios,
        imagen: IconArticles,
        onClick: SLUGS.planesyprecios,
        menu: 'Planes',
        title: 'Planes',
        EMPRESA: 'EMPRESA',
        SUCURSAL: 'SUCURSAL'
    },*/
    {
        id: SLUGS.articulos,
        imagen: IconArticulos,
        onClick: SLUGS.articulos,
        menu: 'Articulos',
        title: 'Artículos',
        EMPRESA: 'EMPRESA',
        SUCURSAL: 'SUCURSAL'
    },
    {
        id: SLUGS.mensajes,
        imagen: IconMensajes,
        items: [1],
        onClick: SLUGS.mensajes,
        menu: 'Mensajes',
        title: 'Mensajes',
        EMPRESA: 'EMPRESA',
        SUCURSAL: 'SUCURSAL'
    },
    {
        id: SLUGS.movimientosinventarioe,
        imagen: IconInventarios,
        items: [1],
        onClick: SLUGS.movimientosinventarioe,
        menu: 'Inventarios',
        title: 'Inventarios',
        ADMINISTRADOR: 'ADMINISTRADOR',
        EMPRESA: 'EMPRESA',
        SUCURSAL: 'SUCURSAL'
    },
    {
        id: SLUGS.cotizaciones,
        imagen: IconVentas,
        items: [1],
        onClick: SLUGS.cotizaciones,
        menu: 'Ventas',
        title: 'Ventas',
        ADMINISTRADOR: 'ADMINISTRADOR',
        EMPRESA: 'EMPRESA',
        SUCURSAL: 'SUCURSAL'
    },
    {
        id: SLUGS.ordencompra,
        imagen: IconCompras,
        items: [1],
        onClick: SLUGS.ordencompra,
        menu: 'Compras',
        title: 'Compras',
        ADMINISTRADOR: 'ADMINISTRADOR',
        EMPRESA: 'EMPRESA',
        SUCURSAL: 'SUCURSAL'
    },
    {
        id: SLUGS.creditocliente,
        imagen: IconCxc,
        items: [1],
        onClick: SLUGS.creditocliente,
        menu: 'Cuentas_X_cobrar',
        title: 'Cuentas por cobrar',
        ADMINISTRADOR: 'ADMINISTRADOR',
        EMPRESA: 'EMPRESA',
        SUCURSAL: 'SUCURSAL'
    },
    {
        id: SLUGS.vxcreditosProveedores,
        imagen: IconCxp,
        items: [1],
        onClick: SLUGS.vxcreditosProveedores,
        menu: 'Cuentas_X_pagar',
        title: 'Cuentas por pagar',
        ADMINISTRADOR: 'ADMINISTRADOR',
        EMPRESA: 'EMPRESA',
        SUCURSAL: 'SUCURSAL'
    },
    {
        id: SLUGS.vxubicacion,
        imagen: IconRuta,
        items: [1],
        onClick: SLUGS.vxubicacion,
        menu: 'Venta_en_Ruta',
        title: 'Venta en ruta',
        ADMINISTRADOR: 'ADMINISTRADOR',
        EMPRESA: 'EMPRESA',
        SUCURSAL: 'SUCURSAL'
    },
    {
        id: SLUGS.pvformascobro,
        imagen: IconDolar,
        items: [1],
        onClick: SLUGS.pvformascobro,
        menu: 'Punto_de_venta',
        title: 'Punto de venta',
        ADMINISTRADOR: 'ADMINISTRADOR',
        EMPRESA: 'EMPRESA',
        SUCURSAL: 'SUCURSAL'
    },
    {
        id: SLUGS.categorias,
        imagen: IconCatalogos,
        items: [1],
        onClick: SLUGS.categorias,
        menu: 'Catalogos',
        title: 'Catalogos',
        ADMINISTRADOR: 'ADMINISTRADOR',
        EMPRESA: 'EMPRESA',
        SUCURSAL: 'SUCURSAL'
    },
    {
        id: SLUGS.soporte,
        imagen: IconSoporte,
        //items: { items },
        onClick: SLUGS.soporte,
        menu: 'Soporte',
        title: 'Soporte',
        ADMINISTRADOR: 'ADMINISTRADOR',
        EMPRESA: 'EMPRESA',
        SUCURSAL: 'SUCURSAL'
    },
    {
        id: SLUGS.planesyprecios,
        imagen: IconCompras,
        //items: { items },
        onClick: SLUGS.planesyprecios,
        menu: 'Planes',
        title: 'Planes',
        ADMINISTRADOR: 'ADMINISTRADOR',
        EMPRESA: 'EMPRESA',
        SUCURSAL: 'SUCURSAL'
    },








        /*
        {
            //id: SLUGS.vxmovimientos,
            imagen: IconArticles,
            //items: { items },
            //onClick: SLUGS.vxmovimientos,
            menu: 'Movimientos',
            title: 'Movimientos',
            ADMINISTRADOR: 'ADMINISTRADOR',
            EMPRESA: 'EMPRESA',
            SUCURSAL: 'SUCURSAL'
        },
        {
            //id: SLUGS.vxmovimientos,
            imagen: IconArticles,
            //items: { items },
            //onClick: SLUGS.vxmovimientos,
            menu: 'ConfigAppMaxventas',
            title: 'App MaxVentas',
            ADMINISTRADOR: 'ADMINISTRADOR',
            EMPRESA: 'EMPRESA',
            SUCURSAL: 'SUCURSAL'
        },
    {
        id: SLUGS.remisiones,
        imagen: IconArticles,
        //items: { items },
        onClick: SLUGS.remisiones,
        menu: 'Ordenes',
        title: 'Ventas',
        EMPRESA: 'EMPRESA',
        SUCURSAL: 'SUCURSAL'
    },
    {
        id: SLUGS.procesos,
        imagen: IconArticles,
        //items: { items },
        //onClick: SLUGS.procesos,
        menu: 'Mensajes',
        title: 'Notificaciones',
        EMPRESA: 'EMPRESA',
        SUCURSAL: 'SUCURSAL'
    },*//*   
        {
            id: SLUGS.compras,
            imagen: IconArticles,
            //items: { items },
            //onClick: SLUGS.ordenes,
            menu: 'Compras',
            title: 'Compras',
            EMPRESA: 'EMPRESA',
            SUCURSAL: 'SUCURSAL'
        },*/
    /*{
        id: SLUGS.categorias,
        imagen: IconArticles,
        //items: { items },
        onClick: SLUGS.categorias,
        menu: 'Catalogos',
        title: 'Catalogos',
        ADMINISTRADOR: 'ADMINISTRADOR',
        EMPRESA: 'EMPRESA',
        SUCURSAL: 'SUCURSAL'
    },*/

    
        /*{
            id: SLUGS.articulos,
            imagen: Reportes,
            items: { items },
            onClick: SLUGS.articulos,
            menu: 'Reportes',
            title: 'Reportes',
            ADMINISTRADOR: 'ADMINISTRADOR',
            EMPRESA: 'EMPRESA',
            SUCURSAL: 'SUCURSAL'
        },
        {
            id: SLUGS.empresa,
            imagen: Configuraciones,
            items: { items },
            onClick: SLUGS.empresa,
            menu: 'Configuraciones',
            title: 'Configuraciones',
            ADMINISTRADOR: 'ADMINISTRADOR',
        }*/];


function SidebarComponent() {
    const { push } = useHistory();
    const isMobile = window.innerWidth <= 1300;
    let [version, setVersion] = React.useState('');

    useEffect(() => {
        fetchConToken(`empresas/GetVersion`)
            .then((response) => { setVersion(response); })
            .catch(alertService.error)
    }, []);

    function renderSwitch() {
        var rol = getDataSession('rol');
        return lista.map((item) => {
            return item.hasOwnProperty(rol) ? (
                <>
                    <MenuItem
                        key={item.id + "princ"}
                        id={item.menu}
                        icon={item.imagen}
                        title={item.title}
                        items={item.items}
                        onClick={() => onClick(item.id, item.menu)}
                    />
                    <SidebarOptionsComponent menu={item.menu} />
                </>
            ) : (
                ''
            );
        });
    }

    async function logout() {
        Swal.fire({
            text: 'Esta apunto de salir del panel',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Salir',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                removeUserSession();
                push('..');
            }
        })
    }

    function onClick(slug, submenu) {
        setDataSession('menu', submenu);
        push(slug);
    }

    return (
        <>
            <Menu isMobile={isMobile} key={"menu00-1"}>
                <div key={"menu000"} >
                    <div key={"menu001"} style={{ paddingTop: 15, paddingBottom: 0 }}>
                        <LogoComponent key={"menu005"} />
                        <div key={"menu01"} className='text-center' style={{ paddingTop: 10 }}>
                            {/*<h6 key={"menu02"} style={{color: '#fff'}}>{getDataSession('rol')}</h6>*/}
                            <p style={{ color: "#fff", fontSize: ".55em" }}>{version.version}</p>
                        </div>
                    </div>
                    <div key={"menu03"} style={{ overflow: 'auto', height: '100%' }}>
                        {renderSwitch()}
                        <MenuItem key={"salir00"} id='logout' title='Salir' onClick={logout} icon={IconSalir} />
                    </div>
                    <div key={"menu04"} className='submenu-sidebar-scroll'>
                        <SidebarOptionsComponent key={"menu05"} />
                    </div>
                </div>
            </Menu>
        </>
    );
}

export default SidebarComponent;